import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import Layout from '../layouts/Layout';
import TextHero from '../components/TextHero/TextHero';
import Integration from '../sections/Integration/Integration';
import StartWorkingTogether from '../sections/StartWorkingTogether/StartWorkingTogether';
import { getKeyPattern } from '../lib/helpers';

const IntegrationPage = ({ data, pageContext, location }) => {
    const { application } = pageContext;
    const pageSettings = data.integrationPageSettings || data.defaultSettings;

    const { siteUrl } = data.site.siteMetadata;
    const pageUrl = siteUrl + location.pathname;

    return (
        <>
            <Helmet>
                <title>{getKeyPattern(pageSettings?.title, application)}</title>
                <meta name="robots" content="noindex" />
                <meta
                    name="description"
                    content={getKeyPattern(
                        pageSettings?.seo_description,
                        application
                    )}
                />
                <meta
                    property="og:site_name"
                    content={getKeyPattern(
                        pageSettings?.seo_title,
                        application
                    )}
                />
                <meta
                    property="og:title"
                    content={getKeyPattern(
                        pageSettings?.seo_title,
                        application
                    )}
                />
                <meta
                    property="og:image"
                    content={pageSettings?.seo_image?.[0]?.localFile.publicURL}
                />
                <meta
                    name="twitter:title"
                    content={getKeyPattern(
                        pageSettings?.seo_title,
                        application
                    )}
                />
                <meta
                    name="keywords"
                    content={getKeyPattern(
                        pageSettings?.seo_keywords,
                        application
                    )}
                />
            </Helmet>
            <Layout>
                <TextHero
                    header={getKeyPattern(pageSettings?.title, application)}
                    subheader={
                        <span className="integration-description">
                            {getKeyPattern(
                                pageSettings?.description,
                                application
                            )}
                            {application.source === 'zapier' && (
                                <a
                                    className="btn integration-description__source"
                                    href={`https://zapier.com/apps/flotiq/integrations/${application.slug}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    View on Zapier
                                </a>
                            )}
                        </span>
                    }
                />
                <Integration
                    {...application}
                    flotiqDescription={pageSettings?.flotiq_description}
                />
                <StartWorkingTogether />
            </Layout>
        </>
    );
};

export const pageQuery = graphql`
    query IntegrationsPageQuery($source: String) {
        integrationPageSettings(source: { eq: $source }) {
            title
            description
            seo_title
            seo_description
            seo_keywords
            seo_image {
                localFile {
                    publicURL
                }
            }
            flotiq_description
            source
        }
        defaultSettings: integrationPageSettings(source: { eq: "" }) {
            title
            description
            seo_title
            seo_description
            seo_keywords
            seo_image {
                localFile {
                    publicURL
                }
            }
            flotiq_description
            source
        }
        site {
            siteMetadata {
                siteUrl
            }
        }
    }
`;

export default IntegrationPage;
